
export const sortByProperty = (propertyName: string, ascending: boolean = true) =>
{
    return (a: any, b: any) => {
        if(a[propertyName] < b[propertyName]) { return ascending ? -1: 1; }
        else if(a[propertyName] > b[propertyName]) { return ascending ? 1 : -1; }
        else { return 0; }
    };
}